import Button from '@/components/Button';
import { FiCheck, FiCopy } from '@/components/react-icons/main';
import clone from '@/lib/clone';
import copyToClipboard from '@/lib/copyToClipboard';
import stepActions from '@/screens/workflows/redux/actions/stepActions';
import { useState } from 'react';
import { FiArrowUpRight } from 'react-icons/fi';

const IdOutput = ({ onClick, output, children, active, index, isSelected, selectableIndex, hidePreviews = false }) => {
  const [hasCopied, setHasCopied] = useState(false);
  const presentation = output?.__meta?.presentation || {};
  const fields = presentation?.fields || {};
  const fieldsAreEmpty = JSON.stringify(fields) === '{}' || JSON.stringify(fields.id) === '{}';
  const entityUrl = presentation?.entityUrl;

  if (JSON.stringify(output) === '{}') {
    return null;
  }

  const handleIndexButtonClick = (e) => {
    e.stopPropagation();
    stepActions.set(`arguments.activeIndex`, index);
  };

  const handleCopyOutput = () => {
    const cleanOutput = clone(output);
    delete cleanOutput?.__meta;

    setHasCopied(true);
    copyToClipboard(JSON.stringify(cleanOutput, null, 2), { toast: true });

    setTimeout(() => {
      setHasCopied(false);
    }, 1000);
  };

  if (hidePreviews) {
    return (
      <div className={`card ${active ? 'active' : ''} ${isSelected ? 'selected' : ''}`}>
        <div className={'children'}>{children}</div>
      </div>
    );
  }

  return (
    <div className={`card ${active ? 'active' : ''} ${isSelected ? 'selected' : ''} ${presentation?.className || ''}`}>
      {!fieldsAreEmpty && (
        <div className={'inner-card'} onClick={onClick}>
          <div className={'main'}>
            <div className={'name'}>{fields.id}</div>
          </div>
          {!!output && <Button size={'xs'} className={'ghost medium'} title={'Copy object to clipboard'} icon={hasCopied ? FiCheck : FiCopy} onClick={handleCopyOutput} />}
          <div className="output-card-actions">
            {entityUrl && (
              <Button size={'xs'} className={'outline medium'} title={'View in external system'} route={entityUrl} icon={FiArrowUpRight} iconPosition="right">
                View
              </Button>
            )}
            {selectableIndex && (
              <Button size={'xs'} className={`filled loop-button ${isSelected ? 'active' : ''}`} onClick={handleIndexButtonClick} title={'Set as Active Loop'}>
                <span>i</span>
                {index + 1}
              </Button>
            )}
          </div>
          {!selectableIndex && !isNaN(index) && <div className={'output-number'}>{index}</div>}
        </div>
      )}
      {fieldsAreEmpty && (
        <div className={'floating'}>
          {!!output && <Button size={'xs'} className={'ghost medium'} title={'Copy object to clipboard'} icon={hasCopied ? FiCheck : FiCopy} onClick={handleCopyOutput} />}
          <div className="output-card-actions">
            {entityUrl && (
              <Button size={'xs'} className={'outline medium'} title={'View in external system'} route={entityUrl} icon={FiArrowUpRight} iconPosition="right">
                View
              </Button>
            )}
            {selectableIndex && (
              <Button size={'xs'} className={`filled loop-button ${isSelected ? 'active' : ''}`} onClick={handleIndexButtonClick} title={'Set as Active Loop'}>
                <span>i</span>
                {index + 1}
              </Button>
            )}
          </div>
          {!selectableIndex && !isNaN(index) && <div className={'output-number empty'}>{index}</div>}
        </div>
      )}
      <div className={'children'}>{children}</div>
    </div>
  );
};

export default IdOutput;
